import React from "react";

const Footer = ({ brandName }) => {
  return (
    <footer id="contact" className="bg-gray-900 text-white py-8 text-center">
      <p>Get in touch: hello@example.com</p>
      <p className="mt-2">
        &copy; {new Date().getFullYear()} {brandName || "Restaurant"}. All
        rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
